import { useCurrentUserStore } from "@/stores/useCurrentUserStore";

/**
 * 組織のクレジット残高が枯渇している間、画面上部へ常時表示するバナー。
 * 制限中であることと理由を全画面共通で示す (解除はクレジット付与により自動で行われる)。
 */
export function CreditExhaustedBanner() {
	const creditExhausted = useCurrentUserStore((s) => s.creditExhausted);

	if (!creditExhausted) return null;

	return (
		<div
			data-testid="credit-exhausted-banner"
			style={{
				position: "fixed",
				top: 12,
				left: "50%",
				transform: "translateX(-50%)",
				zIndex: 1000,
				maxWidth: "calc(100vw - 32px)",
				padding: "8px 16px",
				background: "var(--danger-subtle)",
				color: "var(--danger)",
				borderRadius: "var(--radius-full)",
				boxShadow: "var(--shadow-popover)",
				fontSize: "var(--text-ui)",
				fontWeight: 500,
				textAlign: "center",
			}}
		>
			組織のクレジット残高が不足しているため、エージェントの起動と実行を制限しています。クレジットが付与されると自動的に解除されます。
		</div>
	);
}
